module.exports = __webpack_public_path__ + "img/slogan1.1f3ef41e.png";